import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMessageSquare}=FiIcons;

const ScrollNavbar=()=> {
const [isVisible,setIsVisible]=useState(false);
const whatsappUrl="https://wa.me/5214775954969?text=Quiero%20más%20información";

useEffect(()=> {
const toggleVisibility=()=> {
if (window.pageYOffset > 300) {
setIsVisible(true);
} else {
setIsVisible(false);
}};
window.addEventListener('scroll',toggleVisibility);
return ()=> window.removeEventListener('scroll',toggleVisibility);
},[]);

return ( 
<AnimatePresence> 
{isVisible && ( 
<motion.nav initial={{y: -100,opacity: 0}} animate={{y: 0,opacity: 1}} exit={{y: -100,opacity: 0}} transition={{duration: 0.3,ease: "easeInOut"}} className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md shadow-lg border-b border-gray-700" > 
<div className="container mx-auto px-4 py-3"> 
<div className="flex items-center justify-between"> 
{/* Logo */} 
<div className="flex items-center"> 
<img src="https://www.ticketfactura.com/wp-content/uploads/2025/09/logo-tf-hor.png" alt="TicketFactura Logo" className="h-8 w-auto" /> 
</div> 
{/* WhatsApp Button */} 
<motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-2.5 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105" whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} > 
<SafeIcon icon={FiMessageSquare} className="text-lg" /> 
<span className="hidden sm:inline">Quiero más información</span> <span className="sm:hidden">Info</span> 
</motion.a> 
</div> 
</div> 
</motion.nav> 
)} 
</AnimatePresence> 
);};
export default ScrollNavbar;